export const resources = {
  riCvcp: true,
  hivAidsresources: true,
  dayOne: true,
  sojournerHouse: true,
  elizabaethBuffamChase: true,
  riChildrenAdvocacyCenter: true,
  nationalDomesticViolenceHotline: true,
  nationalResourceCenterOnDomesticViolence: true,
  officeForVictimsOfCrime: true,
  leaAndCourtAdvocateInfo: true,
  vineCrimeVictimAdvocate: true,
  dcyf: true,
  nationalCenterForVictimsOfCrime: true,
  bradleyHospitalAndTidesFamilyService: true,
  familyServicesOfRiAndFamilyCommunityCarePartnership: true,
  dvPartnersUnderRICADVAndCounselingResources: true,
  TRO: true,
  undocumentedInfo: true,
  trafickingSurvivorResources: true,
  legalCounselingRestitutionLink: true,
  legalAssistanceResources: true,
  victimbarLink: true,
  volunteerLawyerProgram: true,
  homelessnessResources: true,
  helplineRI: true,
  CAP: true,
  GLBTQDomesticViolenceProject: true,
  GLAD: true,
  youthPrideInc: true,
  relay: true,
  NSPL: true,
};
